import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { Btn } from '../../components/index';
import { theme } from '../../lib/index';

export default function GoBackButton(comingFromOutside) {
  if (comingFromOutside) {
    return (
      <StyledATag target="_parent" href="https://member.humandesignclub.com/reader/">
        <Btn
          noEndIcon
          buttonName="zurück zur Übersicht"
        />
      </StyledATag>
    );
  }

  return (
    <StyledLink to="/">
      <Btn
        noEndIcon
        buttonName="zurück zur Übersicht"
      />
    </StyledLink>
  );
}

const StyledLink = styled(Link, {})({
  display: 'flex',

  justifyContent: 'center',

  textDecoration: 'none',

  [theme.breakpoints.up('laptop')]: {
    '& > .MuiButton-root:hover': {
      padding: '23px 29px 20px 18px',
    },
  },
});

const StyledATag = styled('a', {})({
  display: 'flex',

  justifyContent: 'center',

  textDecoration: 'none',

  [theme.breakpoints.up('laptop')]: {
    '& > .MuiButton-root': {
      marginBottom: 50,

      '&:hover': {
        padding: '23px 29px 20px 18px',
      },
    },
  },
});
